export default {
  /**
   * 手机号注册
   */
  mobileRegister: "/uc/userloginandreg/mobileRegister",
  /**
   * 发送验证码
   */
  sendMobileCode: "/uc/userloginandreg/sendMobileCode",
  /**
   * 校验验证码
   */
  checkMobileCode: '/uc/userloginandreg/checkMobileCode',
  /**
   * 账号登录
   */
  loginByAccount: "/uc/userloginandreg/loginByAccount",
  /**
   * 验证码登录
   */
  loginByMobileCaptcha: "/uc/userloginandreg/loginByMobileCaptcha",
  /**
   * 忘记密码
   */
  forgetPassword: "/uc/userloginandreg/forgetPassword",
  /**
   * 根据code获取openId
   */
  getOpenId: "/uc/userloginandreg/getOpenId",
  /**
   * 微信登录
   */
  wxLogin: "/uc/userloginandreg/wxLogin",
  /**
   * 微信绑定手机号
   */
  wxBind: "/uc/userloginandreg/wxBindV2",
  /**
   * 修改密码
   */
  changePassword: '/uc/userloginandreg/changePassword'
};
